export const selectStyles = (
	primaryColor = "#00000080",
	height = "48px",
	backgroundColor = "transparent"
) => ({
	control: (styles, { isDisabled, isFocused, selectProps: { error } }) => ({
		...styles,
		border: error
			? "1px solid #FF3B30"
			: isDisabled
				? "0.5px solid #97979733"
				: isFocused
					? `1px solid ${primaryColor}`
					: `1px solid ${primaryColor}`,
		borderRadius: "6px",
		height: `${height}`,
		width: "100%",
		fontSize: "13px",
		fontWeight: "400",
		padding: "0 2px",
		color: isDisabled ? "#979797" : "#1F2937",
		backgroundColor: isDisabled ? "#97979733" : backgroundColor,
		boxShadow: "none",
		outline: "none",
		cursor: "pointer",
		"&:hover": {
			border: `1px solid ${primaryColor}`,
		},
	}),
	menu: (styles) => ({
		...styles,
		border: `1px solid ${primaryColor}`,
		borderRadius: "5px",
		fontSize: "12px",
		fontWeight: "400",
		color: "#1F2937",
		backgroundColor: "#F9F9FB",
		boxShadow: "none",
		outline: "none",
		cursor: "pointer",
		padding: "2px",
		overflowY: "auto",
		position: "absolute",
		top: `${height}`,
		zIndex: 9999,
	}),
	option: (styles, { isSelected }) => ({
		...styles,
		backgroundColor: isSelected ? "#BAD6EF" : "#ffffff",
		color: isSelected ? "#002564" : "#000000",
		borderRadius: "5px",
		fontWeight: isSelected ? "600" : "400",
		cursor: "pointer",
	}),
	singleValue: (styles) => ({
		...styles,
		color: "#1F2937",
	}),
});
